import React from 'react'

const TimeTrackingLoading: React.FC = () => {
  return <></>
}

export { TimeTrackingLoading }
